module.exports = __webpack_public_path__ + "img/050_basis_thb.b39bd5c7.jpg";